module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik05IDBIMC41Mjk0MTJDMC4yMzcxNzYgMCAwIDAuMjM3MTc2IDAgMC41Mjk0MTJDMCAwLjgyMTY0NyAwLjIzNzE3NiAxLjA1ODgyIDAuNTI5NDEyIDEuMDU4ODJIOUM5LjI5MjIzIDEuMDU4ODIgOS41Mjk0MSAwLjgyMTY0NyA5LjUyOTQxIDAuNTI5NDEyQzkuNTI5NDEgMC4yMzcxNzYgOS4yOTIyMyAwIDkgMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQuMjM0ODYgOC40NzA3KSIgZmlsbD0iIzFGMzc1QiIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/svg/market-collapse.svg
// module id = Er2l
// module chunks = 1